export const INTOUCH_PAY_RESPONSE = {
  DEPOSIT_PENDING: "1000",
  DEPOSIT_SUCCESS: "01",
  WITHDRAWAL_ACCEPTED: "2001",
};

const FAILURE_CODES = new Set([
  "0002", "0003", "0004", "0005", "0006", "0007", "0008",
  "2100", "2200", "2300", "2400", "2500", "2600", "2700",
  "1005", "1002", "1008", "1200", "1100", "1300",
  "1101", "1102", "1103", "1104", "1105", "1106", "1107", "1108", "1110",
  "2003", "2102", "2105", "2106", "2107", "2108", "2109", "2110", "2111",
  "2000", "2510", "2518", "2520", "2522", "2525", "2800",
  "3000", "3200",
]);

export const isIntouchPayFailureCode = (code) =>
  FAILURE_CODES.has(String(code || "").trim());

const isTruthyProviderSuccess = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const isPaymentDepositSuccess = (data) => {
  const localStatus = String(data?.deposit?.status || "").toLowerCase();
  if (localStatus === "failed" || localStatus === "cancelled") return false;

  const code = String(data?.providerResponse?.responsecode || "").trim();
  if (isIntouchPayFailureCode(code)) return false;
  if (data?.providerResponse?.success === false) return false;

  if (code === INTOUCH_PAY_RESPONSE.DEPOSIT_SUCCESS) return true;
  if (code === INTOUCH_PAY_RESPONSE.DEPOSIT_PENDING && localStatus === "pending") {
    return true;
  }

  return localStatus === "pending" || localStatus === "success";
};

export const isPaymentWithdrawalSuccess = (data) => {
  const localStatus = String(data?.withdrawal?.status || "").toLowerCase();
  if (localStatus === "failed" || localStatus === "cancelled") return false;

  const code = String(data?.providerResponse?.responsecode || "").trim();
  if (isIntouchPayFailureCode(code)) return false;
  if (data?.providerResponse?.success === false) return false;

  if (code === INTOUCH_PAY_RESPONSE.WITHDRAWAL_ACCEPTED) return true;
  if (localStatus === "success") return true;

  return false;
};
